import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Carousel } from 'react-bootstrap';
import './GalleryCarousel.css'
import img1 from '../assets/DSC_0890.JPG'
import img2 from '../assets/DSC_0901.JPG'
import img3 from '../assets/DSC_0907.JPG'

// import './CarouselComponent.css'; // CSS file for custom styling

const GalleryCarousel= () => {
  return (
    <Carousel id="carouselDemo" interval={2000} controls indicators={false} wrap={true}>
      <Carousel.Item className="active">
        <img src={img1} className="imgeSlided container" alt="Slide 0"/>
        <Carousel.Caption>
          {/* <h5 className='gallery_text'> WSSP Meeting</h5>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Modi, nemo?</p> */}
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item>
        <img src={img2} className="imgeSlided container" alt="Slide 1"/>
        <Carousel.Caption>
          {/* <h5 className='gallery_text'>WSSP Meeting</h5>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Modi, nemo?</p> */}
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item>
        <img src={img3} className="imgeSlided container" alt="Slide 2"/>
        <Carousel.Caption>
          {/* <h5 className='gallery_text'>WSSP Meeting</h5>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Modi, nemo?</p> */}
        </Carousel.Caption>
      </Carousel.Item>

      {/* <div className="carousel-indicators">
        <button type="button" className="active" data-bs-target="#carouselDemo" data-bs-slide-to="0">
          <img src={img1} alt="Slide 0"/>
        </button>
        <button type="button" data-bs-target="#carouselDemo" data-bs-slide-to="1">
          <img src="img2.jpg" alt="Slide 1"/>
        </button>
        <button type="button" data-bs-target="#carouselDemo" data-bs-slide-to="2">
          <img src="img3.jpg" alt="Slide 2"/>
        </button>
      </div> */}
    </Carousel>
  );
}

export default GalleryCarousel;
